import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Plus, Trash, PencilSimple, X, CheckCircle, PaintBrush } from "@phosphor-icons/react";
import HintButton from "@/components/HintButton";

const EMPTY = { name: "", hex: "", active: true };

export default function SilkColors() {
  const [colors, setColors] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");

  const load = async () => {
    const { data } = await api.get("/silk-colors", { params: { only_active: false } });
    setColors(data);
  };
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm(EMPTY); setEditing("new"); setError(""); };
  const openEdit = (c) => { setForm({ name: c.name, hex: c.hex || "", active: c.active }); setEditing(c); setError(""); };

  const save = async (e) => {
    e.preventDefault();
    setError("");
    try {
      if (editing === "new") await api.post("/silk-colors", form);
      else await api.put(`/silk-colors/${editing.id}`, form);
      setEditing(null);
      load();
    } catch (err) { setError(err?.response?.data?.detail || "Erro"); }
  };

  const del = async (id) => {
    if (!confirm("Remover cor de silk?")) return;
    await api.delete(`/silk-colors/${id}`);
    load();
  };

  return (
    <div className="p-6 md:p-10">
      <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
        <div>
          <div className="overline text-zinc-500 mb-2">CADASTROS · SILK</div>
          <h1 className="font-head text-2xl sm:text-3xl font-black tracking-tight">Cores do Silk</h1>
          <HintButton text="Cadastro das cores de tinta utilizadas no silk. Cada pedido usa apenas uma cor de silk — selecionada na tela do pedido." />
        </div>
        <button className="btn" onClick={openNew} data-testid="add-silk-color">
          <Plus size={14} weight="bold" /> Nova Cor
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="silk-colors-grid">
        {colors.length === 0 && (
          <div className="col-span-full text-center py-10 border border-dashed border-zinc-300">
            <PaintBrush size={32} weight="thin" className="mx-auto mb-2 text-zinc-300" />
            <div className="text-zinc-500 text-sm">Sem cores cadastradas.</div>
          </div>
        )}
        {colors.map((c) => (
          <div key={c.id} className={`border border-black bg-white p-4 flex items-center justify-between ${!c.active ? "opacity-50" : ""}`} data-testid={`silk-color-${c.id}`}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 border border-black" style={{ background: c.hex || "#f4f4f5" }}>
                {!c.hex && <PaintBrush size={18} className="w-full h-full p-2 text-zinc-400" />}
              </div>
              <div>
                <div className="font-semibold text-sm">{c.name}</div>
                <div className="text-[10px] text-zinc-500 uppercase tracking-widest">{c.active ? "Ativa" : "Inativa"}</div>
              </div>
            </div>
            <div className="flex gap-1">
              <button onClick={() => openEdit(c)} className="p-2 hover:bg-zinc-100"><PencilSimple size={14} /></button>
              <button onClick={() => del(c.id)} className="p-2 hover:bg-red-50 text-red-500"><Trash size={14} /></button>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-6" onClick={() => setEditing(null)}>
          <div className="glass max-w-md w-full p-8" onClick={(e) => e.stopPropagation()} data-testid="silk-color-modal">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="overline text-zinc-500">{editing === "new" ? "NOVA COR" : "EDITAR COR"}</div>
                <h2 className="font-head text-2xl font-bold">{form.name || "—"}</h2>
              </div>
              <button onClick={() => setEditing(null)}><X size={20} /></button>
            </div>
            <form onSubmit={save} className="space-y-4">
              <div>
                <label className="label">Nome *</label>
                <input className="input" required autoFocus value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="silk-color-name" />
              </div>
              <div>
                <label className="label">Cor (HEX, opcional)</label>
                <div className="flex gap-2 items-center">
                  <input type="color" className="w-14 h-12 border border-zinc-300 cursor-pointer" value={form.hex || "#ffffff"} onChange={(e) => setForm({ ...form, hex: e.target.value })} />
                  <input className="input font-mono" value={form.hex || ""} placeholder="#ffffff" onChange={(e) => setForm({ ...form, hex: e.target.value })} />
                </div>
              </div>
              <label className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} /> Ativa
              </label>
              {error && <div className="border border-[#E60000] bg-red-50 text-[#E60000] text-sm px-3 py-2">{error}</div>}
              <div className="flex gap-3 pt-2">
                <button type="button" className="btn btn-ghost flex-1" onClick={() => setEditing(null)}>Cancelar</button>
                <button type="submit" className="btn flex-1" data-testid="silk-color-save"><CheckCircle size={14} weight="bold" /> Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
